import type { RouteObject } from 'react-router';

import * as SearchJobsHorizonRoute from 'modules/search/pages/Jobs/SearchJobs.horizon-route';
import { SavedSearchRedirectPageLoadable } from 'modules/search/pages/SavedSearchRedirect/SavedSearchRedirectPageLoadable';
import { userDashboardApiFetchSavedSearch } from 'modules/userDashboard/api/savedSearch/userDashboardApiFetchSavedSearch';
import type { AppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import { horizonRouteToObject } from 'routing/utils/horizonRouteToObject';
import { renderLoader } from 'routing/utils/renderLoader/renderLoader';

import { searchGetJobsRoutePath } from './helpers/searchGetJobsRoutePath';
import { savedSearchesRoute } from './search.routes';
import { searchEventsRouteObjects } from './searchEvents.route.objects';
import { searchInternshipsRouteObjects } from './searchInternships.route.objects';
import { searchOrgsRouteObjects } from './searchOrgs.route.objects';
import { searchVolopsRouteObjects } from './searchVolops.route.objects';

export const searchRouteObjects = [
  {
    path: savedSearchesRoute.fullPath,
    ...renderLoader({
      loader: async ({
        params,
      }: AppRouteLoaderArgs<typeof savedSearchesRoute>) =>
        userDashboardApiFetchSavedSearch(params.savedSearchId as string),
      render: (savedSearch) => (
        <SavedSearchRedirectPageLoadable savedSearch={savedSearch} />
      ),
    }),
  },

  ...(['en', 'es', 'pt'] as const).map(
    (locale) =>
      ({
        path: searchGetJobsRoutePath({ lang: locale }),
        ...horizonRouteToObject(SearchJobsHorizonRoute),
      }) satisfies RouteObject,
  ),

  ...searchInternshipsRouteObjects,
  ...searchVolopsRouteObjects,
  ...searchEventsRouteObjects,
  ...searchOrgsRouteObjects,
] satisfies RouteObject[];
